<!-- 合作项目列表 -->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">合作项目</div>
                <el-select
                    class="search-item"
                    v-model="searchData.ProjectId"
                    filterable
                    clearable
                    size="small"
                    @visible-change="projectVisibleChange"
                    placeholder="请选择合作项目"
                >
                    <el-option v-for="optionItem in projectList" :key="optionItem.ProjectId" :label="optionItem.ProjectName" :value="optionItem.ProjectId"> </el-option>
                </el-select>
                <el-button class="search-btn btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showTableSetDialog()">表格设置</el-button>
            </div>
        </div>
        <div class="table-ctn goodlist-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border=""
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @cell-dblclick="handleDBClick"
                @sort-change="sortChange"
                :tableCode="tableCode"
                empty-text="暂无相关库存商品信息"
                v-loading="loading"
                ref="multipleTable"
            >
                <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'APCode'"
                        show-overflow-tooltip
                        fixed="left"
                    >
                        <template slot="header">
                            {{ col.ColumnName }}
                        </template>
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.MainImg" icon="el-icon-picture" type="text" @click="getGoodsImages(scope.row.GoodsId)"></el-button>
                            {{ scope.row.APCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'AutoSerise'"
                    >
                        <template slot="header">
                            {{ col.ColumnName }}
                        </template>
                        <template slot-scope="scope">
                            <el-tag
                                @click="showSeries(scope.row)"
                                v-if="scope.row.SeriesCount > 0 || scope.row.IsCommonSeries"
                                type="danger"
                                effect="plain"
                                size="small"
                                style="padding: 0 2px"
                                >{{ scope.row.IsCommonSeries ? '通用' : scope.row.SeriesCount }}</el-tag
                            >
                            {{ scope.row.AutoSerise }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'SpaceInvens'"
                    >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>{{ scope.row.SpaceInvens }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50, 100]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="库存商品搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-goods-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item :label="searchShowSets.JointSearch.Title" v-if="searchShowSets.JointSearch.IsShow">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            size="small"
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.APCode.Title" v-if="searchShowSets.APCode.IsShow">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            :placeholder="searchShowSets.APCode.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAPCodeLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.GoodName.Title" v-if="searchShowSets.GoodName.IsShow">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            :placeholder="searchShowSets.GoodName.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.AutoSerise.Title" v-if="searchShowSets.AutoSerise.IsShow">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            :placeholder="searchShowSets.AutoSerise.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Invent.Title" v-if="searchShowSets.Invent.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_4"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_4')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent2"
                                v-if="searchData.Symbol == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.BrandId.Title" v-if="searchShowSets.BrandId.IsShow">
                        <el-select
                            ref="search_5"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Cate.Title" v-if="searchShowSets.Cate.IsShow">
                        <el-select
                            ref="search_6"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.SpaceType.Title" v-if="searchShowSets.SpaceType.IsShow">
                        <el-select ref="search_7" multiple size="small" class="search-item" style="width: 100%" v-model="searchData.SpaceType">
                            <el-option key="0" label="标准仓" value="0"></el-option>
                            <el-option key="1" label="临时仓" value="1"></el-option>
                            <el-option key="2" label="废品仓" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.GoodDesc.Title" v-if="searchShowSets.GoodDesc.IsShow">
                        <el-input
                            @focus="selectAutoHandle('search_8')"
                            ref="search_8"
                            class="search-item"
                            size="small"
                            v-model="searchData.GoodDesc"
                            :placeholder="searchShowSets.GoodDesc.Placeholder"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Size.Title" v-if="searchShowSets.Size.IsShow">
                        <el-input
                            @focus="selectAutoHandle('search_9')"
                            ref="search_9"
                            class="search-item"
                            size="small"
                            v-model="searchData.Size"
                            :placeholder="searchShowSets.Size.Placeholder"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.MarketPrice.Title" v-if="searchShowSets.MarketPrice.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol1" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_10"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.MarketPrice1"
                                @focus="selectAutoHandle('search_10')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.MarketPrice2"
                                v-if="searchData.Symbol1 == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Price.Title" v-if="searchShowSets.Price.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol2" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_11"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Price1"
                                @focus="selectAutoHandle('search_11')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Price2"
                                v-if="searchData.Symbol2 == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.CostPrice.Title" v-if="searchShowSets.CostPrice.IsShow">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol3" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_12"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.CostPrice1"
                                @focus="selectAutoHandle('search_12')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.CostPrice2"
                                v-if="searchData.Symbol3 == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="searchShowSets.Origin.Title" v-if="searchShowSets.Origin.IsShow">
                        <el-autocomplete
                            ref="search_13"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Origin"
                            :fetch-suggestions="searchOrigin"
                            :debounce="500"
                            :placeholder="searchShowSets.Origin.Placeholder"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchOriginLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" icon="el-icon-setting" class="search-btn" type="primary" v-if="permission.advancedSearch" @click="searchSets">{{
                        permission.advancedSearch
                    }}</el-button>
                </div>
            </div>
        </el-dialog>
        <!--    查看库存    -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :edit="false" :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="searchSetVisible">
                <searchSets :tableCode="tableCode" @closeDialog="closeDialog"></searchSets>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closetableSetDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closetableSetDialog"></tableSets>
            </div>
        </el-dialog> 
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import searchSets from '@/components/common/searchSets.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import tableSets from '@/components/common/tableSets_v2.vue';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        breadcrumb,
        elTableColumn,
        searchSets,
        ElImageViewer,
        tableSets
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_0) {
                        this.$refs.search_0.focus();
                        this.searchIndex = 0;
                    }
                });
            }
        }
    },
    data() {
        return {
            datetime1: [],
            datetime2: [],
            projectList: [],
            isCGoodsName: false,
            isCCate: false,
            isCBrand: false,
            isCOrigin: false,
            seriesVisible: false,
            tableSetsVisible:false,
            tableCode: 'ProjectGoodsTable',
            loading: false,
            optionLoading: false,
            isStopReq: false,
            isStopChildReq: false,
            isStartSearch: false,
            searchIndex: 0,
            goodsMsg: {},
            multipleSelection: [],
            goodsId: '',
            brand: [],
            choosedGood: {},
            typeList1: [],
            addAPVisible: false, //新增
            APMsgVisible: false, //编辑
            downloadUrl: this.$util.QN_URL_BASE,
            searchData: {
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Symbol1: '',
                MarketPrice1: 0,
                MarketPrice2: 0,
                Symbol2: '',
                Price1: 0,
                Price2: 0,
                Symbol3: '',
                CostPrice1: 0,
                CostPrice2: 0,
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                GoodDesc: '',
                SpaceType: [],
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: 15,
                SearchType: 2,
                Origin: '',
                ProjectId: ''
            },
            dialogTitle: '新增汽配', //dialog标题
            dialogVisible: false,
            searchSetVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            CorrectInvenVisible: false,
            columnShowSets: [],
            isShowPerf: false,
            searchShowSets: {
                JointSearch: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                APCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                AutoSerise: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                SpaceType: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                BrandId: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Cate: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                GoodDesc: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Invent: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Size: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                MarketPrice: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Price: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                CostPrice: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Origin: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                }
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            separator: '',
            goodNameOptions: [],
            autoSeriseOptions: [],
            canSearch: true,
            srcList: [],
            showViewer: false,
            addInMergeGoodsVisible: false,
            isShowUpdate: false,
            isShowProject: false,
            percentage: 0, //进度
            saveLoading: false,
            bacthUpdateData: {
                UpdateKey: '',
                UpdateValue: '',
                saveCount: 0, //已保存数
                totalCount: 0, //实际需要修改的总数量
                SearchData: { page: 1 },
                GoodsIds: []
            },
            apCategoryList: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isCanTBSet: false
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        if (this.tableCode) this.getSetsData();
        this.getSearchCrtSetsData();
        this.getJointSearchSets();
        this.getConfigByCodes();
    },
    mounted() {
        this.$util.getSysConfig('splbycfpc').then(res => {
            if (res.Result) {
                this.searchData.SpaceType = ['0', '1'];
            }
            this.getTableData();
        });

        this.permission = this.$util.getPermission('AutoPartsManage');
    },
    activated() {
        //使用了keepalive每一次进入页面都会触发activated勾子
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['ygsfkzdylb', 'hzxmxzset'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                                case 'ygsfkzdylb': //是否可自定义列表
                                    this.isCanTBSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //按下一页、上一页、重新查询的时候，停下子接口的查询
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                //批量修改时取消回车事件
                if (!that.isShowUpdate) {
                    e.preventDefault();
                    if (
                        (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                        (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                        (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                        (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                        (!that.$refs.search_13 || !that.$refs.search_13.suggestionVisible) &&
                        (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                        (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                        that.canSearch
                    ) {
                        that.handleSearch();
                    }
                    that.canSearch = true;
                    that.isStartSearch = false;
                }
            }
            //ESC
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                if (
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) ||
                    (that.$refs.search_13 && that.$refs.search_13.suggestionVisible)
                ) {
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_13 && that.$refs.search_13.suggestionVisible) that.$refs.search_13.suggestions = [];
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                e.preventDefault();
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                if (!this.dialogVisible && !that.showViewer) {
                    e.preventDefault();
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //左键
            if (key === 37) {
                if (!that.dialogVisible && !that.showViewer) {
                    e.preventDefault();
                    if (that.searchData.page !== 1) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 12) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_13 || !that.$refs.search_13.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_13 || !that.$refs.search_13.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].GoodsId);
            }
            this.bacthUpdateData.GoodsIds = idList;
        },
        gotoImportPage() {
            this.$router.push('/inventoryManage/goods/importExcel');
        },
        gotoExportPage() {
            this.$router.push('/inventoryManage/goods/exportExcel');
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.goodsId = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        showAddAPDialog(item) {
            if (item) {
                this.goodsId = item.GoodsId;
            } else {
                this.goodsId = '';
            }
            // 打开页面
            this.$router.push(`/inventoryManage/goods/addgoods?EntpTempGoodsId=${this.goodsId}`);
        },
        closeAddAPDialog(isEdit) {
            this.addAPVisible = false;
            if (isEdit) {
                this.getTableData();
            }
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .finally(() => {});
        },
        searchGoodsType() {
            if (this.typeList1.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Symbol1: '',
                MarketPrice1: 0,
                MarketPrice2: 0,
                Symbol2: '',
                Price1: 0,
                Price2: 0,
                Symbol3: '',
                CostPrice1: 0,
                CostPrice2: 0,
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                GoodDesc: '',
                SpaceType: [],
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: 15,
                SearchType: 2,
                Origin: ''
            };
            this.datetime1 = [];
            this.datetime2 = [];
        },
        // 删除汽配
        delGoods(item) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除选中汽配吗?',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/DeleteEnterprisePart',
                            data: {
                                EntpTempGoodsId: item.GoodsId
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        bacthDelGoods() {
            let that = this;
            let selecteds = this.multipleSelection;
            if (!selecteds) that.$util.warningMsg('请选择要删除的配件');

            let ids = [];

            if (selecteds.length == 0) that.$util.warningMsg('请选择要删除的配件');
            else
                for (let i = 0; i < selecteds.length; i++) {
                    let item = selecteds[i];
                    if (!item.CanDeleted) {
                        that.$util.warningMsg('选择的结果包含不能删除的配件');
                        return;
                    }

                    ids.push(item.GoodsId);
                }

            if (ids.length > 0)
                that.$util.elConfirm({
                    content: '确定要批量删除选中汽配吗?',
                    noMsg: true,
                    confirm() {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpGoods/BacthDeleteEnterprisePart',
                                data: {
                                    GoodsIds: ids
                                }
                            })
                            .then(() => {
                                that.$util.successMsg('批量删除成功');
                                that.getTableData();
                            })
                            .catch(() => {});
                    }
                });
            else that.$util.warningMsg('请选择要删除的配件');
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                if (this.searchData.Symbol) {
                    //''空值isNan 也是返会false 所以要加parseInt做强制转换
                    if (this.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(this.searchData.Invent1))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                        if (isNaN(parseInt(this.searchData.Invent2))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(this.searchData.Invent1))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    }
                } else {
                    this.searchData.Invent1 = 0;
                    this.searchData.Invent2 = 0;
                }
                this.loading = true;
                this.isStopReq = true;
                this.isStopChildReq = false;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetEntpProjectPartList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        if (!data) {
                            this.tableData = [];
                            this.tableDataLength = res.count;
                            return;
                        }
                        let goodsIds = [];
                        for (let i = 0; i < data.length; i++) {
                            goodsIds.push(data[i].GoodsId);
                            data[i].AutoSeries = [];
                            data[i].LoadSpaceInvent = true;
                        }
                        this.tableData = data;
                        this.tableDataLength = res.count;
                        this.getGoodsOtherData(goodsIds);
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        async getGoodsOtherData(goodsIds) {
            let that = this;
            if (goodsIds && goodsIds.length > 0) {
                for (let i = 0; i < goodsIds.length; i++) {
                    if (!this.isStopChildReq) {
                        that.loopGetData(goodsIds[i]);
                        await that.$util.sleep(150);
                    } else return;
                }
            }
        },
        loopGetData(id) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetSinglePartData',
                    data: { GoodsId: id, SpaceType: that.searchData.SpaceType },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.GoodsId == data.GoodsId) {
                            item.LoadSpaceInvent = false;
                            item.SpaceInvens = data.SpaceInvens;
                            item.IsCommonSeries = data.IsCommonSeries;
                            item.SeriesCount = data.SeriesCount;
                            item.IsHaveInOutRecord = data.IsHaveInOutRecord;
                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.GoodsId) {
                this.showAPMsgDialog(event.GoodsId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        showCorrectInventories() {
            this.CorrectInvenVisible = true;
        },
        closeCorrectInventories() {
            this.CorrectInvenVisible = false;
        },
        searchSets() {
            if (this.tableCode) {
                this.searchSetVisible = true;
            }
        },
        closeDialog(isEdit) {
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'JointSearch':
                            this.searchShowSets.JointSearch.IsShow = item.IsShow;
                            this.searchShowSets.JointSearch.Width = item.Width;
                            this.searchShowSets.JointSearch.Placeholder = item.Placeholder;
                            this.searchShowSets.JointSearch.Title = item.Title;
                            this.searchShowSets.JointSearch.SortNum = item.SortNum;
                            break;
                        case 'APCode':
                            this.searchShowSets.APCode.IsShow = item.IsShow;
                            this.searchShowSets.APCode.Width = item.Width;
                            this.searchShowSets.APCode.Placeholder = item.Placeholder;
                            this.searchShowSets.APCode.Title = item.Title;
                            this.searchShowSets.APCode.SortNum = item.SortNum;
                            break;
                        case 'GoodName':
                            this.searchShowSets.GoodName.IsShow = item.IsShow;
                            this.searchShowSets.GoodName.Width = item.Width;
                            this.searchShowSets.GoodName.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodName.Title = item.Title;
                            this.searchShowSets.GoodName.SortNum = item.SortNum;
                            break;
                        case 'AutoSerise':
                            this.searchShowSets.AutoSerise.IsShow = item.IsShow;
                            this.searchShowSets.AutoSerise.Width = item.Width;
                            this.searchShowSets.AutoSerise.Placeholder = item.Placeholder;
                            this.searchShowSets.AutoSerise.Title = item.Title;
                            this.searchShowSets.AutoSerise.SortNum = item.SortNum;
                            break;
                        case 'SpaceType':
                            this.searchShowSets.SpaceType.IsShow = item.IsShow;
                            this.searchShowSets.SpaceType.Width = item.Width;
                            this.searchShowSets.SpaceType.Placeholder = item.Placeholder;
                            this.searchShowSets.SpaceType.Title = item.Title;
                            this.searchShowSets.SpaceType.SortNum = item.SortNum;
                            break;
                        case 'BrandId':
                            this.searchShowSets.BrandId.IsShow = item.IsShow;
                            this.searchShowSets.BrandId.Width = item.Width;
                            this.searchShowSets.BrandId.Placeholder = item.Placeholder;
                            this.searchShowSets.BrandId.Title = item.Title;
                            this.searchShowSets.BrandId.SortNum = item.SortNum;
                            break;
                        case 'Cate':
                            this.searchShowSets.Cate.IsShow = item.IsShow;
                            this.searchShowSets.Cate.Width = item.Width;
                            this.searchShowSets.Cate.Placeholder = item.Placeholder;
                            this.searchShowSets.Cate.Title = item.Title;
                            this.searchShowSets.Cate.SortNum = item.SortNum;
                            break;
                        case 'GoodDesc':
                            this.searchShowSets.GoodDesc.IsShow = item.IsShow;
                            this.searchShowSets.GoodDesc.Width = item.Width;
                            this.searchShowSets.GoodDesc.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodDesc.Title = item.Title;
                            this.searchShowSets.GoodDesc.SortNum = item.SortNum;
                            break;
                        case 'Invent':
                            this.searchShowSets.Invent.IsShow = item.IsShow;
                            this.searchShowSets.Invent.Width = item.Width;
                            this.searchShowSets.Invent.Placeholder = item.Placeholder;
                            this.searchShowSets.Invent.Title = item.Title;
                            this.searchShowSets.Invent.SortNum = item.SortNum;
                            break;
                        case 'Size':
                            this.searchShowSets.Size.IsShow = item.IsShow;
                            this.searchShowSets.Size.Width = item.Width;
                            this.searchShowSets.Size.Placeholder = item.Placeholder;
                            this.searchShowSets.Size.Title = item.Title;
                            this.searchShowSets.Size.SortNum = item.SortNum;
                            break;
                        case 'MarketPrice':
                            this.searchShowSets.MarketPrice.IsShow = item.IsShow;
                            this.searchShowSets.MarketPrice.Width = item.Width;
                            this.searchShowSets.MarketPrice.Placeholder = item.Placeholder;
                            this.searchShowSets.MarketPrice.Title = item.Title;
                            this.searchShowSets.MarketPrice.SortNum = item.SortNum;
                            break;
                        case 'Price':
                            this.searchShowSets.Price.IsShow = item.IsShow;
                            this.searchShowSets.Price.Width = item.Width;
                            this.searchShowSets.Price.Placeholder = item.Placeholder;
                            this.searchShowSets.Price.Title = item.Title;
                            this.searchShowSets.Price.SortNum = item.SortNum;
                            break;
                        case 'CostPrice':
                            this.searchShowSets.CostPrice.IsShow = item.IsShow;
                            this.searchShowSets.CostPrice.Width = item.Width;
                            this.searchShowSets.CostPrice.Placeholder = item.Placeholder;
                            this.searchShowSets.CostPrice.Title = item.Title;
                            this.searchShowSets.CostPrice.SortNum = item.SortNum;
                            break;
                        case 'Origin':
                            this.searchShowSets.Origin.IsShow = item.IsShow;
                            this.searchShowSets.Origin.Width = item.Width;
                            this.searchShowSets.Origin.Placeholder = item.Placeholder;
                            this.searchShowSets.Origin.Title = item.Title;
                            this.searchShowSets.Origin.SortNum = item.SortNum;
                            break;
                    }
                });
            });
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            let callback = cb;
            if (this.apCodeForm.stopLoad) return;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (callback) {
                    callback(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            let callback = cb;
            if (this.goodNameForm.stopLoad) return;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (callback) {
                    callback(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            let callback = cb;
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (callback) {
                    callback(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            let callback = cb;
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (callback) {
                    callback(this.originOptions);
                }
            });
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        stopSearch() {
            this.canSearch = false;
        },
        closeViewer() {
            this.showViewer = false;
        },
        async getGoodsImages(goodsId) {
            this.srcList = [];
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsImages',
                data: { goodsId: goodsId }
            });
            if (data) {
                this.srcList = data;
            }
            this.showViewer = true;
        },
        //匹配单位
        searchUnit(queryString, cb) {
            if (this.unitList && this.unitList.length > 0) {
                let list = this.unitList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getConfigData(cb);
            }
        },
        //获取单位
        getConfigData(cb) {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
                if (cb) {
                    cb(this.unitList);
                }
            });
        },
        //匹配品牌
        searchBrand(queryString, cb) {
            if (this.brandList && this.brandList.length > 0) {
                let list = this.brandList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEnterprisePartBrandList(cb);
            }
        },
        //获取品牌分类
        getEnterprisePartBrandList(cb) {
            this.$util.searchGoodsBrand().then(res => {
                this.brandList = res;
                if (cb) {
                    cb(this.brandList);
                }
            });
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Text);
                }
            };
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.apCategoryList = [...this.apCategoryList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChangecar(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCate('');
            } else {
                if (!that.bacthUpdateData.UpdateValue) {
                    that.bacthUpdateData.UpdateValue = that.cateForm.key;
                }
            }
        },
        showSeries(item) {
            if (item && item.GoodsId) {
                this.goodsId = item.GoodsId;
                this.seriesVisible = true;
            } else {
                this.goodsId = '';
                this.seriesVisible = false;
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getAuthCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closetableSetDialog(isEdit) {
            this.tableSetsVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        }
    }
};
</script>
<style lang="less" scoped>
#search-goods-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.autocompleteInput .el-input input {
    width: 260px;
    height: 32px;
}
.e-item1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
}
.e-item2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
}
.el-autocomplete-suggestion {
    width: 300px !important;
}

.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
</style>
